export default __webpack_public_path__ + "static/media/pp-girl.80cfcd33.webp";